import * as actions from "../actions/Type";
const intialState = {
  list_sell_raport: [],
  view_sell_raport: {},
  list_rent_raport: [],
  view_rent_raport: {},
  // box report
  calculate_box: {},
  // Agent Raport
  all_sell_agent_contracts: [],
  all_rent_agent_contracts: [],
  all_takemoney_agent_bills: [],
  all_paradan_agent_bills: [],
  all_avilable_agent_property: [],
  all_required_agent_property: [],
  all_calculations_agent: {},
  paradan_view_agent: {},
  money_view_agent: {},
  agent_kpis: [],
  agent_kpis_addproperty: [],
  agent_kpis_addrequired: [],
  //income report
  income_earings: [],
  calculation_income_obj: {},
};
const RaportReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.SELL_DAILY_RAPORT:
      return {
        ...state,
        list_sell_raport: action.payload,
      };
    case actions.SELL_MONTHLY_RAPORT:
      return {
        ...state,
        list_sell_raport: action.payload,
      };
    case actions.SELL_YERALY_RAPORT:
      return {
        ...state,
        list_sell_raport: action.payload,
      };
    case actions.SELL_FROMTO_RAPORT:
      return {
        ...state,
        list_sell_raport: action.payload,
      };

    case actions.RENT_DAILY_RAPORT:
      return {
        ...state,
        list_rent_raport: action.payload,
      };
    case actions.RENT_MONTHLY_RAPORT:
      return {
        ...state,
        list_rent_raport: action.payload,
      };
    case actions.RENT_YERALY_RAPORT:
      return {
        ...state,
        list_rent_raport: action.payload,
      };
    case actions.RENT_FROMTO_RAPORT:
      return {
        ...state,
        list_rent_raport: action.payload,
      };
    case actions.VIEW_RENT_RAPORT:
      return {
        ...state,
        view_rent_raport: action.payload,
      };
    case actions.VIEW_SELL_RAPORT:
      return {
        ...state,
        view_sell_raport: action.payload,
      };
    // Project raport
    case actions.BOX_REPORT_REALESTATE:
      return {
        ...state,
        calculate_box: action.payload,
      };
    // Agent Raport performance
    case actions.AGENT_SELL_CONTRACTS:
      return {
        ...state,
        all_sell_agent_contracts: action.payload,
        all_rent_agent_contracts: [],
        all_takemoney_agent_bills: [],
        all_paradan_agent_bills: [],
      };
    case actions.AGENT_RENT_CONTRACTS:
      return {
        ...state,
        all_rent_agent_contracts: action.payload,
        all_sell_agent_contracts: [],
        all_takemoney_agent_bills: [],
        all_paradan_agent_bills: [],
      };
    case actions.AGENT_TAKEMONEY_CONTRACTS:
      return {
        ...state,
        all_takemoney_agent_bills: action.payload,
        all_sell_agent_contracts: [],
        all_rent_agent_contracts: [],
        all_paradan_agent_bills: [],
      };
    case actions.AGENT_PARADAN_CONTRACTS:
      return {
        ...state,
        all_paradan_agent_bills: action.payload,
        all_sell_agent_contracts: [],
        all_rent_agent_contracts: [],
        all_takemoney_agent_bills: [],
      };
    case actions.AGENT_ADD_PROPERTY:
      return {
        ...state,
        all_avilable_agent_property: action.payload,
      };
    case actions.AGENT_ADD_REQUIRED_PROPERTY:
      return {
        ...state,
        all_required_agent_property: action.payload,
      };
    case actions.AGENT_GET_CALCULATIONS:
      return {
        ...state,
        all_calculations_agent: action.payload,
      };
    case actions.AGENT_VIEW_PARADAN:
      return {
        ...state,
        paradan_view_agent: action.payload,
      };
    case actions.AGENT_VIEW_TAKEMONEY:
      return {
        ...state,
        money_view_agent: action.payload,
      };
    case actions.KPI_OF_AGENT:
      return {
        ...state,
        agent_kpis: action.payload,
      };
    case actions.KPI_OF_AGENT_PROPERTY:
      return {
        ...state,
        agent_kpis_addproperty: action.payload,
      };
    case actions.KPI_OF_AGENT_REQUIRED:
      return {
        ...state,
        agent_kpis_addrequired: action.payload,
      };
    case actions.INCOME_REPORT_REALESTATE:
      return {
        ...state,
        income_earings: action.payload,
      };
    case actions.INCOME_REPORT_TOTALINCOME:
      return {
        ...state,
        calculation_income_obj: action.payload,
      };
    default:
      return { ...state };
  }
};

export default RaportReducer;
